import React from "react";

const HeaderTitle = ({ children }: { children: React.ReactNode }) => {
  return (
    <h1 className="text-24 font-bold leading-32 text-gray-800">{children}</h1>
  );
};

export default HeaderTitle;
